const TodayPlanning = () => import("@/components/TodayPlanning/TodayPlanning.vue")
const AgencyHome = () => import("@/components/AgencyHome/AgencyHome.vue");
const MessagePopup = () => import("@/layouts/MessagePopupLayout/MessagePopupLayout.vue");
import { MESSAGE_POPUP } from "@/constants/employeeMenu";
import { USER_TYPE } from "../../constants/home";
import moment from "moment";

moment.locale("fr");
export default {
  components: {
    TodayPlanning,
    AgencyHome,
    MessagePopup
  },
  computed: {
    messagePopupType() {
      return MESSAGE_POPUP.TYPE;
    },
    userType() {
      return USER_TYPE.EMPLOYEE;
    },
  },
};
